import "./header.component.css";
import { Link } from "react-router-dom";
import Logo from "../assets/logo.png";

function HeaderComponent(
    props: Readonly<{
        className?: string,
        [key: string]: any
    }>
) {
    const { className, ...overflowProps } = props;

    return (
        <div className={`header-component no-select ${className ?? ""}`} {...overflowProps}>
            <div className="header-body">
                <Link className="header-logo-link" to="/" aria-label="TCG Awards Home">
                    <img src={Logo} alt="TCG Awards" />
                </Link>

                <Link className="header-title-link" to="/">
                    <p className="header-title">TCG AWARDS</p>
                </Link>

                <Link className="header-logo-link" to="/" aria-label="TCG Awards Home">
                    <img src={Logo} alt="" aria-hidden="true" />
                </Link>
            </div>
        </div>
    );
}

export default HeaderComponent;